<template>
    <div class="ah-page analysis-income-statement">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>自結損益表</h1>
                    </div>
                    <div class="actions">
                        <el-button icon="el-icon-printer" @click="print">列印</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel no-print">
                <div class="panel-body">
                    <div class="action-bar">
                        <div class="left">
                            <search-form>
                                <search-form-item label="期間">
                                    <el-date-picker
                                        v-model="dateRange"
                                        type="daterange"
                                        start-placeholder="開始時間"
                                        end-placeholder="結束時間"
                                        prefix-icon=" "
                                        range-separator="~"
                                        value-format="timestamp"
                                        style="margin-right: 10px"
                                        :clearable="false"
                                        :picker-options="pickerYearOptions"
                                        :default-time="['00:00:00', '23:59:59']"
                                        @change="fetchTableData"
                                    ></el-date-picker>
                                </search-form-item>
                                <search-form-item label="金額為 0 的科目">
                                    <el-radio v-model="isShowZeroItems" :label="true" @change="fetchTableData">顯示</el-radio>
                                    <el-radio v-model="isShowZeroItems" :label="false" @change="fetchTableData">隱藏</el-radio>
                                </search-form-item>
                            </search-form>
                        </div>
                        <div class="right">
                            <el-button @click="save" style="margin-right: 5px; line-height: ">
                                存檔
                            </el-button>
                            <el-dropdown>
                                <el-button> 載入存檔<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :disabled="true">
                                        <span v-if="savedDatas.length > 0">僅儲存於當前電腦</span>
                                        <span v-if="savedDatas.length == 0">（尚未有存檔紀錄）</span>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-for="(item, index) in savedDatas" :key="`saved-${index}`" @click.native="fillData(item)">
                                        {{ parseInt(item.dateRange[0]) | dateFormater("YYYY年MM月dd日") }}
                                        ~
                                        {{ parseInt(item.dateRange[1]) | dateFormater("YYYY年MM月dd日") }}
                                        <el-button v-if="!isQR()" size="mini" icon="el-icon-delete" style="margin-left: 5px" @click="delSave($event, index)"> </el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ah-panel">
                 <div class="panel-body">
                    <div class="doc-header">
                        <div class="company-name">{{ companyName }}<span v-if="isTrying">（試用）</span></div>
                        <div class="doc-name">自結損益表</div>
                        <div class="date">{{ startDateTxt }} 至 {{ endDateTxt }}</div>
                        <div class="date" style="text-align: right; font-size: 8pt; margin-bottom: 10px">製表日期：{{ todayDateTxt }}</div>
                    </div>
                    <!-- 列印用表格 -->
                    <table cellspacing="0" cellpadding="0" class="print-table">
                        <thead>
                            <tr>
                                <th class="sign"></th>
                                <th class="name">
                                    <span>項目</span>
                                </th>
                                <th class="amount">金額</th>
                                <th class="percentage">佔營收 %</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="item in tableData">
                                <tr :key="item.id" class="group-row">
                                    <td class="sign">
                                        <span v-if="item.type === 1">+</span>
                                        <span v-if="item.type === -1">-</span>
                                        <span v-if="item.type === 0">=</span>
                                    </td>
                                    <td class="name">
                                        <span>{{ item.name }}</span>
                                    </td>
                                    <td class="amount">
                                        <money :v="item.amount" />
                                    </td>
                                    <td class="percentage">{{ item.percentage }} %</td>
                                </tr>
                                <template v-for="subItem in item.children">
                                    <tr :key="subItem.id" class="child-row" v-if="!hideChildItems">
                                        <td class="sign"></td>
                                        <td class="name">
                                            <span v-if="subItem.name === '成本支出轉資產' || subItem.name === '進貨折讓退回收款'">
                                                (減項)
                                            </span>
                                            <span>
                                                {{ subItem.name }}
                                                <span v-if="subItem.name === '成本支出轉資產' && !!title"> （{{ title }}） </span>
                                            </span>
                                        </td>
                                        <td class="amount">
                                            <money :v="subItem.amount" />
                                        </td>
                                        <td class="percentage">{{ subItem.percentage }} %</td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>

                    <!-- 實際顯示表格 -->
                    <el-table
                        ref="table"
                        :data="tableData"
                        row-key="id"
                        class="income-statement-table"
                        :row-class-name="tableRowClassName"
                        :tree-props="{ children: 'children' }"
                        :default-expand-all="true"
                        v-loading="isLoading"
                    >
                        <el-table-column prop="name" label="項目" fixed>
                            <template slot="header">
                                <el-button size="mini" icon="el-icon-plus" @click="openAll"> 展開 </el-button>
                                <el-button size="mini" icon="el-icon-minus" @click="closeAll"> 收闔 </el-button>
                            </template>
                            <template slot-scope="scope">
                                <span
                                    :class="{
                                        'group-name': scope.row.level === 0,
                                        'child-name': scope.row.level === 1,
                                        'has-child': scope.row.children && scope.row.children.length > 0
                                    }"
                                >
                                    <span
                                        v-if="scope.row.level === 0"
                                        :class="{
                                            'ah-inout-sign': true,
                                            add: scope.row.type === 1,
                                            minus: scope.row.type === -1,
                                            equal: scope.row.type === 0
                                        }"
                                    ></span>
                                    <span class="name-txt">
                                        <span v-if="scope.row.name === '成本支出轉資產' || scope.row.name === '進貨折讓退回收款'" class="sub-label">
                                            減項
                                        </span>
                                        <span>{{ scope.row.name }}</span>
                                        <ah-tip v-if="scope.row.tip">{{ scope.row.tip }}</ah-tip>
                                        <span v-if="scope.row.name === '成本支出轉資產'">
                                            （
                                            <el-input v-model="title" style="width: 150px" size="small" placeholder="填寫項目名稱" />
                                            ）
                                        </span>
                                    </span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="金額" align="right" width="250">
                            <template slot-scope="scope">
                                <money-input :ref="scope.row.id" v-if="scope.row.isManual === true" v-model="scope.row.amount" size="small" align="right" allow-negative @change="updateTableNumbers" />
                                <Money v-else :v="scope.row.amount" round />
                            </template>
                        </el-table-column>
                        <el-table-column prop="percentage" label="佔營收%" align="right" width="150">
                            <template slot-scope="scope"> {{ percentageText(scope.row.percentage) }} % </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import SearchForm from '@/components/ui/SearchForm/SearchForm.vue';
import SearchFormItem from '@/components/ui/SearchForm/SearchFormItem.vue';

export default {
    components: {
        SearchForm,
        SearchFormItem,
    },
    data() {
        return {
            SAVEKEY: 'income-state-saves',
            isLoading: false,
            isShowZeroItems: true,
            savedDatas: [],
            dateRange: [null, null],
            tableData: [],
            hideChildItems: false,
            title: null,
            tableDataTemplate: [
                {
                    id: '4',
                    name: '營業收入（未稅）',
                    type: 1,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'sales-return',
                    name: '銷貨退回',
                    type: -1,
                    isManual: true,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'sales-discount',
                    name: '銷貨折讓',
                    type: -1,
                    isManual: true,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'net-operating-income',
                    name: '營業淨收入',
                    type: 0,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: '5',
                    name: '營業成本',
                    type: -1,
                    children: [
                        {
                            id: 'salary-cost',
                            name: '薪資成本',
                            tip: '人力薪資成本 (屬於成本的薪資支出)',
                            isManual: true,
                            amount: 0,
                            percentage: 0,
                            level: 1,
                        },
                    ],
                    lastChildren: [
                        {
                            id: 'special-to-assets',
                            name: '成本支出轉資產',
                            tip: '成本項目轉資產金額',
                            isManual: true,
                            amount: 0,
                            percentage: 0,
                            level: 1,
                            coefficient: -1,
                        },
                    ],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'gross-profit',
                    name: '營業毛利',
                    type: 0,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: '6',
                    name: '營業費用',
                    type: -1,
                    children: [],
                    lastChildren: [
                        {
                            id: 'depreciation',
                            name: '各項折舊',
                            isManual: true,
                            amount: 0,
                            percentage: 0,
                            level: 1,
                        },
                        {
                            id: 'amortization',
                            name: '各項耗竭及攤提',
                            isManual: true,
                            amount: 0,
                            percentage: 0,
                            level: 1,
                        },
                    ],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'operating-income',
                    name: '營業收益',
                    type: 0,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: '7',
                    name: '營業外收入',
                    type: 1,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: '8',
                    name: '營業外支出',
                    type: -1,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'pre-tax-income',
                    name: '稅前損益',
                    type: 0,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: '9',
                    name: '營利事業所得稅',
                    type: -1,
                    isManual: true,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
                {
                    id: 'net-income',
                    name: '稅後淨利',
                    type: 0,
                    children: [],
                    amount: 0,
                    percentage: 0,
                    level: 0,
                },
            ],
        };
    },
    mounted() {
        this.init();
        this.fetchTableData();
        this.reloadSaveDatas();
    },
    computed: {
        ...mapGetters({ isTrying: 'menu/isTrying' }),
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        todayDateTxt() {
            return moment().format('YYYY年MM月DD日');
        },
        startDateTxt() {
            return moment(parseInt(this.dateRange[0], 10)).format('YYYY年MM月DD日');
        },
        endDateTxt() {
            return moment(parseInt(this.dateRange[1], 10)).format('YYYY年MM月DD日');
        },
        pickerYearOptions() {
            const START_YEAR = 2020;
            const CURR_YEAR = new Date().getFullYear();
            const shortcuts = [];
            for (let y = CURR_YEAR; y >= START_YEAR; y -= 1) {
                shortcuts.push({
                    text: `${y}`,
                    onClick(picker) {
                        const sd = Number(
                            moment([y])
                                .startOf('year')
                                .format('x'),
                        );
                        const ed = Number(
                            moment([y])
                                .endOf('year')
                                .format('x'),
                        );
                        picker.$emit('pick', [sd, ed]);
                    },
                });
            }
            return { shortcuts };
        },
    },
    methods: {
        init() {
            const today = moment();
            this.dateRange = [today.startOf('year').format('x'), today.endOf('year').format('x')];
        },
        reloadSaveDatas() {
            this.savedDatas = JSON.parse(localStorage.getItem(this.SAVEKEY)) ?? [];
        },
        openAll() {
            this.hideChildItems = false;
            this.tableData.forEach((item) => {
                this.$refs.table.toggleRowExpansion(item, true);
            });
        },
        closeAll() {
            this.hideChildItems = true;
            this.tableData.forEach((item) => {
                this.$refs.table.toggleRowExpansion(item, false);
            });
        },
        async fetchTableData() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/CompositeIncomeStatement/GetReport',
                    method: 'GET',
                    params: {
                        StartDate: this.dateRange[0],
                        EndDate: this.dateRange[1],
                    },
                });
                this.updateTableData(resp.data.groups);
            } finally {
                this.isLoading = false;
            }
        },
        updateTableData(data) {
            // 從資料模板複製一份
            this.tableData = _.cloneDeep(this.tableDataTemplate);

            // 使用 groupNo 逐一找到對應項目，塞入 children
            data.forEach((group) => {
                if (group.groupNo === 9) return; // 剔除所得稅(9)，只採用手動輸入

                const tableItem = this.tableData.find((n) => n.id === group.groupNo.toString());
                if (tableItem) {
                    let newChildren = group.items.map((item, index) => ({
                        id: `${item.sno}-${index}`,
                        name: item.itemName,
                        amount: Math.round(item.amount),
                        rawAmount: Math.round(item.amount),
                        percentage: 0,
                        level: 1,
                    }));

                    if (!this.isShowZeroItems) {
                        newChildren = newChildren.filter((child) => child.amount > 0);
                    }

                    tableItem.children = tableItem.children.concat(newChildren);
                }
            });

            // 加入資料後處理方法
            this.tableData.forEach((group) => {
                const g = group;
                // 加入模板中後置子項目(lastChildren)
                if (g.lastChildren) {
                    g.children = g.children.concat(g.lastChildren);
                }
            });

            // 更新數字
            this.updateTableNumbers();

            if (this.hideChildItems) {
                setTimeout(() => {
                    this.closeAll();
                }, 1);
            } else {
                setTimeout(() => {
                    this.openAll();
                }, 1);
            }
        },
        updateTableNumbers() {
            // 薪資支出要扣掉手動輸入的薪資成本
            const no5 = this.tableData.find((g) => g.id === '5'); // 營業成本
            const no6 = this.tableData.find((g) => g.id === '6'); // 營業費用
            no6.children[0].amount = no6.children[0].rawAmount - no5.children[0].amount;

            // 群組 amonut 加總 children
            this.tableData.forEach((group) => {
                if (!group.isManual) {
                    const g = group;
                    // const total = group.children.reduce(
                    //     (a, b) => a + b.amount,
                    //     0,
                    // );
                    let total = 0;
                    group.children.forEach((item) => {
                        if (item.coefficient === -1 || item.name === '進貨折讓退回收款') {
                            total -= item.amount;
                        } else {
                            total += item.amount;
                        }
                    });
                    g.amount = total;
                }
            });

            // 計算群組公式
            const no4 = this.tableData.find((g) => g.id === '4'); // 營業收入
            const srn = this.tableData.find((g) => g.id === 'sales-return'); // 銷貨退回
            const sdt = this.tableData.find((g) => g.id === 'sales-discount'); // 銷貨折讓
            const noi = this.tableData.find((g) => g.id === 'net-operating-income'); // 營業淨收入
            const gsp = this.tableData.find((g) => g.id === 'gross-profit'); // 營業毛利
            const oie = this.tableData.find((g) => g.id === 'operating-income'); // 營業收益
            const no7 = this.tableData.find((g) => g.id === '7'); // 營業外收入
            const no8 = this.tableData.find((g) => g.id === '8'); // 營業外支出
            const pti = this.tableData.find((g) => g.id === 'pre-tax-income'); // 稅前損益
            const no9 = this.tableData.find((g) => g.id === '9'); // 營利事業所得稅
            const nie = this.tableData.find((g) => g.id === 'net-income'); // 稅後損益

            // 營業淨收入 = 營業收入(4) - 銷貨退回 - 銷貨折讓
            noi.amount = no4.amount - srn.amount - sdt.amount;

            // 營業毛利 = 營業淨收入 - 營業成本(5)
            gsp.amount = noi.amount - no5.amount;

            // 營業收益 = 營業毛利 - 營業費用(6)
            oie.amount = gsp.amount - no6.amount;

            // 稅前損益 = 營業收益 + 營業外收入(7) - 營業外支出(8)
            pti.amount = oie.amount + no7.amount - no8.amount;

            // 稅後損益 = 稅前損益 - 營利事業所得稅(9)
            nie.amount = pti.amount - no9.amount;

            // 計算佔營收 %
            const denominator = no4.amount;
            this.tableData.forEach((group) => {
                const g = group;
                g.percentage = this.normalizeNumber(g.amount / denominator);

                group.children.forEach((child) => {
                    const c = child;
                    c.percentage = this.normalizeNumber(c.amount / denominator);
                });
            });
        },
        normalizeNumber(num) {
            return parseFloat(Math.round(num * 10000) / 100).toFixed(2);
        },
        tableRowClassName({ row }) {
            const classNames = [];
            if (row.level === 0) classNames.push('group-row');
            if (row.type === 1) classNames.push('add');
            if (row.type === -1) classNames.push('minus');
            if (row.type === 0) classNames.push('sum');
            return classNames.join(' ');
        },
        print() {
            window.print();
        },
        save() {
            // 讀取目前所有存檔
            const allDatas = JSON.parse(localStorage.getItem(this.SAVEKEY)) ?? [];

            // 取得目前輸入參數
            const newData = {
                dateRange: this.dateRange,
                'sales-return': this.$refs['sales-return'].value, // 銷貨退回
                'sales-discount': this.$refs['sales-discount'].value, // 銷貨折讓
                'salary-cost': this.$refs['salary-cost'].value, // 薪資成本
                'special-to-assets': this.$refs['special-to-assets'].value, // 特定費用轉資產
                depreciation: this.$refs.depreciation.value, // 各項折舊
                amortization: this.$refs.amortization.value, // 各項耗竭及攤提
                9: this.$refs['9'].value, // 營利事業所得稅
                title: this.title,
            };

            // 加入到存檔最上方
            allDatas.unshift(newData);

            // 存進 localStoage
            localStorage.setItem(this.SAVEKEY, JSON.stringify(allDatas));

            this.$message({
                message: '已儲存',
                showClose: true,
                type: 'success',
            });
            this.reloadSaveDatas();
        },
        fillData(data) {
            this.dateRange = data.dateRange;
            this.fetchTableData().then(() => {
                this.tableData.find((g) => g.id === 'sales-return').amount = data['sales-return'];
                this.tableData.find((g) => g.id === 'sales-discount').amount = data['sales-discount'];

                const no5 = this.tableData.find((g) => g.id === '5');
                no5.children[0].amount = data['salary-cost'];
                no5.children[no5.children.length - 1].amount = data['special-to-assets'];

                const no6 = this.tableData.find((g) => g.id === '6');
                no6.children[no6.children.length - 2].amount = data.depreciation;
                no6.children[no6.children.length - 1].amount = data.amortization;

                this.tableData.find((g) => g.id === '9').amount = data['9'];
                this.title = data.title;

                this.updateTableNumbers();
            });
        },
        delSave(event, indexToDelete) {
            // 讀取目前所有存檔
            const allDatas = JSON.parse(localStorage.getItem(this.SAVEKEY)) ?? [];

            // 刪除
            allDatas.splice(indexToDelete, 1);

            // 存進 localStoage
            localStorage.setItem(this.SAVEKEY, JSON.stringify(allDatas));

            this.reloadSaveDatas();
            event.stopPropagation();
            event.preventDefault();
        },

        percentageText(percentage) {
            if (percentage.includes('NaN') || percentage.includes('Infinity')) {
                return '--';
            }
            return percentage;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.analysis-income-statement {
    .action-bar {
        margin: 0 0 15px 0;
        display: flex;
        justify-content: space-between;
    }
    @media print {
        .action-bar {
            display: none;
        }
    }
    .datepicker-label {
        display: inline-block;
        margin-right: 24px;
        font-size: 10pt;
        color: #888;
    }

    .doc-header {
        margin-top: 20px;
        text-align: center;
        padding: 20px 0 0px 0;

        @media print {
            margin-top: 0;
            border-top: 0;
            padding: 0;
        }

        .company-name {
            font-size: 12pt;
            @media print {
                font-size: 11pt;
            }
        }
        .doc-name {
            font-size: 13pt;
            font-weight: bold;
            margin: 3px 0;

            @media print {
                margin: 2px 0;
                font-size: 11pt;
            }
        }
        .date {
            font-size: 10pt;
            @media print {
                font-size: 9pt;
            }
        }
    }

    .income-statement-table {
        margin-bottom: 50px;
        width: 100%;
        line-height: 100%;

        @media screen {
            display: block;
        }
        @media print {
            display: none;
        }

        td {
            padding: 3px 0;
        }

        .group-row.el-table__row {
            td {
                font-weight: bold;
                font-size: 11.5pt;
            }

            &.add {
                background-color: #f3faf2;
            }
            &.add.hover-row td {
                background-color: #e9f9e7;
            }
            &.minus {
                background-color: #fcf5f5;
            }
            &.minus.hover-row td {
                background-color: #f8e9e9;
            }
            &.sum {
                background-color: #f5f7fa;
            }
            &.sum.hover-row td {
                background-color: #ecf1f9;
            }
        }

        .sub-label {
            color: red;
            font-size: 9pt;
            padding: 1px 2px;
            border-radius: 4px;
            border: 1px solid red;
            margin-right: 5px;
        }

        .group-name {
            margin: 0 0 0 37px;

            &.has-child {
                margin: 0 0 0 14px;
            }

            .name-txt {
                padding: 0 0 0 5px;
            }
        }

        .child-name {
            margin: 0 0 0 50px;
        }
    }

    .print-table {
        width: 100%;
        line-height: 130%;
        font-size: 8pt;

        @media screen {
            display: none;
        }
        @media print {
            display: table;
        }

        td {
            padding: 0;
            .money {
                font-weight: normal;
            }
        }

        th.sign,
        td.sign {
            width: 15pt;
            text-align: center;
        }

        th.name,
        td.name {
            text-align: left;
        }

        th.amount,
        td.amount,
        th.percentage,
        td.percentage {
            text-align: right;
        }

        tr.group-row td {
            border-top: 1px solid #000;
        }
        tr.child-row td.name {
            padding-left: 20pt;
        }
    }
}
</style>
